import { render, staticRenderFns } from "./Infobip.vue?vue&type=template&id=e6d3cf64&scoped=true&"
import script from "./Infobip.vue?vue&type=script&lang=js&"
export * from "./Infobip.vue?vue&type=script&lang=js&"
import style0 from "./Infobip.vue?vue&type=style&index=0&id=e6d3cf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d3cf64",
  null
  
)

export default component.exports